import { render, staticRenderFns } from "./AddPlatformStockTemplateComponent.vue?vue&type=template&id=da1f9868&"
import script from "./AddPlatformStockTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./AddPlatformStockTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports